import * as Sentry from '@sentry/browser';
import React from 'react';
import VConsole from 'vconsole';

import MaintenanceGate from 'src/components/Maintenance/MaintenanceGate';

const isProduction = process.env.GATSBY_STAGE === 'production';
const SENTRY_DSN = process.env.GATSBY_SENTRY_DSN;

// init before React mounts so the network panel captures every request;
// the switch stays hidden (see src/html.js) until the 5+5 click gesture
export const onClientEntry = () => {
  // gatsby-plugin-offline is removed; returning clients may still hold its
  // registration — clean it up here, and static/sw.js self-destructs for
  // clients whose page JS never runs. runs before React mounts, so it must
  // never throw
  try {
    if (typeof navigator.serviceWorker?.getRegistrations === 'function') {
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => registrations.forEach((r) => r.unregister()))
        .catch(() => {});
    }
    // unregister 先跑贏時 static/sw.js 不會安裝,舊 precache 要在這裡清
    if (typeof window.caches?.keys === 'function') {
      window.caches
        .keys()
        .then((keys) => keys.forEach((key) => window.caches.delete(key)))
        .catch(() => {});
    }
  } catch (error) {
    console.log(error);
  }
  try {
    new VConsole();

    let leftClickCount = 0;
    let rightClickCount = 0;

    window.addEventListener('click', (event) => {
      if (event.clientX < window.innerWidth / 2) {
        leftClickCount++;
      } else {
        rightClickCount++;
        if (leftClickCount !== 5) {
          leftClickCount = 0;
          rightClickCount = 0;
        }
      }
      if (leftClickCount === 5 && rightClickCount === 5) {
        document.querySelector('.vc-switch').classList.add('show');
      }
    });
  } catch (error) {
    console.log(error);
  }
};

// 移除 src/html.js 內嵌的初始載入 spinner。它是 #___gatsby 的兄弟節點,React 不
// 管理它,必須自己摘掉(舊 webview 不一定有 Element.remove)
export const onInitialClientRender = () => {
  try {
    const el = document.getElementById('___initial_loading');
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  } catch (error) {
    console.log(error);
  }
};

if (isProduction && SENTRY_DSN) {
  try {
    Sentry.init({
      dsn: SENTRY_DSN,
      tracesSampleRate: 1.0,
    });
  } catch (err) {
    console.log(err);
  }
}

export const wrapPageElement = ({ element }) => (
  <MaintenanceGate>{element}</MaintenanceGate>
);
